import { render, staticRenderFns } from "./AuthForgot.vue?vue&type=template&id=1a2107b3&scoped=true&"
import script from "./AuthForgot.vue?vue&type=script&lang=js&"
export * from "./AuthForgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2107b3",
  null
  
)

export default component.exports